// XIcon.js
import React from "react";

const XIcon = ({ size = 32, round = false }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: round ? "50%" : "0%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000", // Background for contrast
        padding: "4px", // Adds some space around the SVG
      }}
    >
      <svg
        width="80%"  // Adjust size inside the container
        height="80%"
        viewBox="0 0 24 24"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.5 2H21L14.5 10L22 22H15.5L10.5 14.5L4.5 22H1L8.5 13L1 2H7.5L12.5 8.5L17.5 2ZM16.5 20H18.5L6.5 4H4.5L16.5 20Z" />
      </svg>
    </div>
  );
};

export default XIcon;
